import _createClass from "/tmp/builds/4d7ed541-3f67-43f7-b5c3-19fa9b4a8a98-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/tmp/builds/4d7ed541-3f67-43f7-b5c3-19fa9b4a8a98-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var Info = /*#__PURE__*/_createClass(
/**
 * @constructor
 * @param {string} property
 * @param {string} attribute
 */
function Info(property, attribute) {
  _classCallCheck(this, Info);

  /** @type {string} */
  this.property = property;
  /** @type {string} */

  this.attribute = attribute;
});
/** @type {string|null} */

Info.prototype.space = null;
Info.prototype.boolean = false;
Info.prototype.booleanish = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.number = false;
Info.prototype.commaSeparated = false;
Info.prototype.spaceSeparated = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.mustUseProperty = false;
Info.prototype.defined = false;